import { render, staticRenderFns } from "./ProductPanel.vue?vue&type=template&id=1d86dfad&"
import script from "./ProductPanel.vue?vue&type=script&lang=js&"
export * from "./ProductPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductPanel.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,SwatchSelect: require('/opt/build/repo/storefront/components/molecules/Product/SwatchSelect.vue').default,PrimaryButton: require('/opt/build/repo/storefront/components/atoms/Button/PrimaryButton.vue').default,Translated: require('/opt/build/repo/storefront/components/legacy/global/translated.vue').default,OutlineButton: require('/opt/build/repo/storefront/components/atoms/Button/OutlineButton.vue').default,ShippingTimer: require('/opt/build/repo/storefront/components/legacy/global/shipping-timer.vue').default})
